.about-page {
  background: var(--color-bg);
  min-height: 100vh;
  padding-bottom: 80px;
}

/* HERO SECTION */
.about-hero {
  padding: 160px 0 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.about-hero::before {
  content: '';
  position: absolute;
  top: -20%;
  left: 50%;
  transform: translateX(-50%);
  width: 80vw;
  height: 80vw;
  background: radial-gradient(circle, rgba(var(--color-primary-rgb), 0.15) 0%, transparent 60%);
  z-index: 0;
  pointer-events: none;
}

.about-hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.about-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 24px;
  color: var(--color-text-primary);
  letter-spacing: -0.02em;
}

.about-subtitle {
  font-size: 1.25rem;
  color: var(--color-text-secondary);
  line-height: 1.6;
}

/* TEAM SECTION */
.about-team-section {
  padding: 80px 0;
}

.about-section-header {
  text-align: center;
  margin-bottom: 60px;
}

.about-section-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--color-text-primary);
}

.about-section-header p {
  font-size: 1.1rem;
  color: var(--color-text-secondary);
}

/* TEAM GRID */
.about-team-grid {
  display: grid;
  gap: 40px;
  max-width: 1150px;
  margin: 0 auto;
}

@media (min-width: 992px) {
  .about-team-grid {
    grid-template-columns: 1fr 1.2fr 1fr;
    align-items: center;
  }
}

@media (max-width: 991px) {
  .about-team-grid {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  }
}

/* TEAM CARD */
.about-team-card {
  background: var(--color-surface);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
}

.about-team-card:hover {
  transform: translateY(-12px);
  border-color: rgba(var(--color-primary-rgb), 0.2);
  box-shadow: 0 20px 40px rgba(var(--color-primary-rgb), 0.12);
}

.team-card-image-wrapper {
  width: 100%;
  height: 380px;
  position: relative;
  overflow: hidden;
  background: var(--color-bg-alt);
}

.ceo-card-wide .team-card-image-wrapper {
  height: 420px;
}

.team-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  transition: transform 0.5s ease;
}

.about-team-card:hover .team-card-image {
  transform: scale(1.08);
}

.team-card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
  background: linear-gradient(to top, var(--color-surface) 0%, transparent 100%);
  pointer-events: none;
}

.team-card-content {
  padding: 0 30px 40px;
  position: relative;
  z-index: 2;
  margin-top: -20px;
}

.team-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 8px;
}

.team-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
}

.team-linkedin {
  color: #0077b5;
  background: rgba(0, 119, 181, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.team-linkedin:hover {
  background: #0077b5;
  color: #fff;
  transform: scale(1.1);
}

.team-role {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-primary);
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.team-bio {
  color: var(--color-text-secondary);
  line-height: 1.6;
  font-size: 0.95rem;
  margin: 0;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .about-title {
    font-size: 2.5rem;
  }
  
  .about-hero {
    padding: 120px 20px 60px;
  }
  
  .about-team-section {
    padding: 40px 20px;
  }
}
